module.exports = __webpack_public_path__ + "img/feed-activity.e41fdb0c.png";